import React, { useRef, useEffect } from 'react';

function AnimaltHatterPart() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };
    resize();
    window.addEventListener('resize', resize);
    const alakzatok = Array.from({length: 20}, () => ({
      x: Math.random() * canvas.width, y: Math.random() * canvas.height,
      meret: Math.random() * 60 + 20,
      vx: (Math.random() - 0.5) * 0.3, vy: (Math.random() - 0.5) * 0.3,
      szin: ['#1a73e8','#34a853','#9c27b0','#f9ab00','#00bcd4','#ea4335'][Math.floor(Math.random()*6)],
      alpha: Math.random() * 0.06 + 0.02,
      forgat: Math.random() * Math.PI * 2,
      forgSeb: (Math.random() - 0.5) * 0.008,
      tipus: Math.floor(Math.random() * 3),
    }));
    const rajzol = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      alakzatok.forEach(a => {
        a.x += a.vx; a.y += a.vy; a.forgat += a.forgSeb;
        if (a.x < -a.meret) a.x = canvas.width + a.meret;
        if (a.x > canvas.width + a.meret) a.x = -a.meret;
        if (a.y < -a.meret) a.y = canvas.height + a.meret;
        if (a.y > canvas.height + a.meret) a.y = -a.meret;
        ctx.save(); ctx.globalAlpha = a.alpha; ctx.fillStyle = a.szin;
        if (a.tipus === 0) {
          ctx.beginPath(); ctx.arc(a.x, a.y, a.meret/2, 0, Math.PI*2); ctx.fill();
        } else if (a.tipus === 1) {
          ctx.translate(a.x, a.y); ctx.rotate(a.forgat);
          ctx.beginPath(); ctx.moveTo(0, -a.meret/2); ctx.lineTo(a.meret/2*0.866, a.meret/4); ctx.lineTo(-a.meret/2*0.866, a.meret/4); ctx.closePath(); ctx.fill();
        } else {
          ctx.translate(a.x, a.y); ctx.rotate(a.forgat);
          ctx.fillRect(-a.meret/4, -a.meret/4, a.meret/2, a.meret/2);
        }
        ctx.restore();
      });
      animId = requestAnimationFrame(rajzol);
    };
    rajzol();
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize', resize); };
  }, []);
  return <canvas ref={canvasRef} style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 0}}/>;
}

const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap');
  .partner-wrapper * { font-family: 'Nunito', sans-serif !important; }
  @keyframes felugrikPart { 0% { transform: translateY(20px); opacity: 0; } 100% { transform: translateY(0); opacity: 1; } }
  @keyframes pulzalPart { 0%,100% { transform: scale(1); } 50% { transform: scale(1.06); } }
`;

function PartnerekOldal() {
  return (
    <div className="partner-wrapper" style={{minHeight: '100vh', background: 'linear-gradient(135deg, #f8f9ff 0%, #f0f7ff 50%, #f5fff8 100%)', padding: '3rem 2rem', position: 'relative', overflow: 'hidden'}}>
      <style>{globalStyles}</style>
      <AnimaltHatterPart/>
      <div style={{position: 'relative', zIndex: 1, maxWidth: '700px', margin: '0 auto', textAlign: 'center'}}>

        <div style={{animation: 'felugrikPart 0.5s ease-out'}}>
          <div style={{display: 'inline-flex', alignItems: 'center', gap: '10px', background: 'rgba(255,255,255,0.9)', border: '2px solid #1a73e8', borderRadius: '50px', padding: '10px 24px', fontSize: '15px', fontWeight: '800', color: '#1a73e8', marginBottom: '1.5rem', boxShadow: '0 4px 16px rgba(26,115,232,0.12)'}}>
            <span style={{fontSize: '22px'}}>🤝</span> Partnereink
          </div>

          <div style={{fontSize: '80px', marginBottom: '1rem', animation: 'pulzalPart 3s ease-in-out infinite'}}>🌱</div>

          <h1 style={{fontSize: '32px', fontWeight: '900', color: '#1a1a2e', marginBottom: '1rem'}}>
            Hamarosan itt lesznek <span style={{background: 'linear-gradient(135deg, #1a73e8, #34a853)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'}}>partnereink!</span>
          </h1>

          <p style={{fontSize: '16px', color: '#666', maxWidth: '480px', margin: '0 auto 2rem', fontWeight: '600', lineHeight: 1.7}}>
            A NetOkos jelenleg még nem rendelkezik hivatalos partnerekkel. Ahogy növekszik a platform, ezen az oldalon fogjuk bemutatni azokat a szervezeteket, iskolákat és szakmai partnereket, akikkel együtt dolgozunk a gyerekek biztonságosabb internetezéséért.
          </p>

          <div style={{background: 'rgba(255,255,255,0.95)', borderRadius: '20px', padding: '1.5rem 2rem', border: '2px solid #f0f0f0', boxShadow: '0 4px 16px rgba(0,0,0,0.05)', maxWidth: '460px', margin: '0 auto 2rem'}}>
            <p style={{fontSize: '14px', color: '#888', margin: 0, lineHeight: 1.6}}>
              📧 Partnerségi lehetőségek iránt érdeklődik? Írjon nekünk: <strong style={{color: '#1a73e8'}}>info.netokos@gmail.com</strong>
            </p>
          </div>

          <a href="/" style={{color: '#1a73e8', fontWeight: '800', fontSize: '15px', textDecoration: 'none'}}>← Vissza a főoldalra</a>
        </div>

      </div>
    </div>
  );
}

export default PartnerekOldal;